import React, { useRef, useState } from "react";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import { useTranslation } from "next-i18next";

const CommentsSection = ({ comments }) => {
  const { t } = useTranslation("blogs");
  const [openIndex, setOpenIndex] = useState(0);
  const contentRefs = useRef([]);

  const toggleIndex = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };
  return (
    <div className="`w-full box-border pb-[40px] lg:pb-[60px] px-6 sm:px-6 lg:px-20 max-w-[1600px] mx-auto">
      <h2 className=" font-medium text-[28px] sm:text-[32px] lg:text-[40px] leading-[120%] m-0 mb-6">
        {t("blogs.commentTitle")}
      </h2>
      <div className="w-full box-border flex flex-col items-start justify-start gap-4 max-w-full">
        {comments?.map((item, index) => {
          const isOpen = openIndex === index;

          return (
            <div
              key={index}
              className={`w-full box-border rounded-[12px] p-3 cursor-pointer transition-all duration-300 ${
                isOpen
                  ? "bg-black text-white"
                  : "bg-white text-black border border-gray-500 border-solid"
              }`}
            >
              <div className="w-full flex flex-col items-start justify-start">
                <div
                  className="w-full flex flex-row items-center justify-between cursor-pointer"
                  onClick={() => toggleIndex(index)}
                >
                  <h2 className="m-0 text-[16px] leading-[140%] font-medium">
                    {item?.name}
                  </h2>
                  {isOpen ? (
                    <AiOutlineMinus fontSize={16} />
                  ) : (
                    <AiOutlinePlus fontSize={16} />
                  )}
                </div>
                <div
                  ref={(el) => (contentRefs.current[index] = el)}
                  className="transition-all duration-300 ease-in-out overflow-hidden text-[16px]"
                  style={{
                    maxHeight: isOpen
                      ? `${contentRefs.current[index]?.scrollHeight}px`
                      : "0px",
                  }}
                >
                  <p className="leading-[150%] text-[14px] m-0 mt-3">
                    {item?.comment}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CommentsSection;
